    <!-- 
    import treeSelectDialog from '@/components/common/treeSelectDialog';
    <el-form-item label="部门" label-width="96px">
      <el-input v-model="params.DpName" class="long_inp" placeholder="请选择" @focus="openDpSelect" readonly />
    </el-form-item>
    <tree-select-dialog ref="dpTreeSelect" in-dialog @select-multiple="setDp" title="部门列表" key-id="DpId" key-name="部门名称" key-value="DpName"
      :func="dpApi.list" :default-value="dpArr" />
    dpApi: require('@/api/ent/dp').default,
    this.dpArr = [];
    openDpSelect() {
      this.$refs.dpTreeSelect.open();
    },
    setDp(e,n) {
      this.dpArr = e;
      this.params.DpName = n;
    }, 
    -->
<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog" @opened="onOpened"
    @closed="isShow = false">
    <div class="select_box" v-if="isShow">
      <div class="select_table tree_box">
        <div id="box_title">{{keyName}}</div>
        <el-tree
          ref="tree"
          :node-key="keyId"
          :data="showData"
          :props="props"
          show-checkbox
          default-expand-all
          :default-checked-keys="defaultCheckedKeys"
          check-strictly
          @check-change="checkChange"
          style="margin: 5px;">
        </el-tree>
      </div>
      <div class="select_table">
        <span style="vertical-align: -webkit-baseline-middle;">已选</span>
        <el-button type="primary" @click="clear" :disabled="checkedData.length == 0"
          style="float: right;">清空</el-button>
        <el-table :data="checkedData" border max-height="530" style="width: 100%;margin-top: 14px;">
          <el-table-column :prop="keyValue" :label="keyName" align="center" />
          <el-table-column prop="name" label="操作" width="65" align="center">
            <template slot-scope="{row,$index}">
              <el-button type="text" @click="deleteRow(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog },
  mixins: [listDialogMixins],
  data() {
    return {
      isShow: false,
      treeData: [],
      checkedData: [],
      props: {},
      defaultCheckedKeys: [],
    };
  },
  props: {
    title: {
      type: String,
      default: "选择",
    },
    func: {
      type: Function,
      default: undefined,
    },
    children: {
      type: String,
      default: "children",
    },
    keyId: {
      type: String,
      default: "Id",
    },
    keyValue: {
      type: String,
      default: "No",
    },
    keyName: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: Array,
      default: null,
    },
  },
  methods: {
    onOpened() {
      this.props = { label: this.keyValue, children: this.children };
      this.treeData = [];
      this.showData = [];
      this.defaultCheckedKeys = this.defaultValue.map(x => { return x[this.keyId] });
      this.checkedData = [].concat(this.defaultValue);
      this.getTreeData();
    },
    getTreeData() {
      this.func({}).then(res => {
        if (res.Code == 0 && res.Data.length) {
          this.treeData = res.Data;
          this.showData = this.$commonJs.toTreeData(res.Data, this.keyId);
          this.isShow = true;
        }
      })
    },
    checkChange(node,checked) {
      if(checked) this.checkedData.push(node);
      else {
        let index = this.checkedData.findIndex(x => x[this.keyId] == node[this.keyId]);
        if(index > -1) this.checkedData.splice(index,1);
      }
    },
    deleteRow(e, index) {
      this.$refs.tree.setChecked(e[this.keyId],false);
      this.checkedData.splice(index, 1);
    },
    clear() {
      this.$refs.tree.setCheckedNodes([]);
      this.checkedData = [];
    },
    selectMultiple() {
      const arr = this.checkedData.map(x => { return x[this.keyValue] }).join(",");
      const arr2 = this.checkedData.map(x => { return x[this.keyId] });
      this.$emit('select-multiple', this.checkedData, arr, arr2);
      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.select_box {
  display: flex;
  justify-content: space-between;
  .select_table {
    width: 49%;
  }
  #box_title {
    text-align: center;
    line-height: 36px;
    border-bottom: 1px solid #eee;
    color: #999;
    font-size: 14px;
    font-weight: bold;
  }
  .tree_box {
    border: 1px solid #eee;
    /deep/ .el-tree-node__content {
      margin-top: 2px;
      margin-bottom: 2px;
    } 
  }
}
</style>